import { showNotify } from "vendor/application/disptach";
import { AmplitudeAPI } from "@api/Amplitude";
import { IntentsAPI } from "../../../infrastructure";

export const sendIntent = async (intent, access, project, props, device_id, user, dispatch, returnToList) => {
    try {
      delete intent.id;
      const obj = new IntentsAPI(project.id, access, props, intent);
      await obj.post_intent();
  
      new AmplitudeAPI({
        event_type: "Intent created",
        device_id,
        user_id: user.email,
      }).eventLog();
  
      dispatch(showNotify({ message: "intents", type: "create", severity: "success" }));
      returnToList();
    } catch (err) {
      dispatch(showNotify({ message: err, severity: "error" }));
    }
  };
  